import React, { useEffect } from 'react';
import getUrlParams from '../elements/getUrlParams';
import axios from 'axios';
import config from '../../config/environment';

export default function BackEndInvoice () {
    useEffect(() => {
        const main = async () => {
            const urlParamsObj = getUrlParams();
            if (!urlParamsObj.orderHash) { return alert('Invalid orderHash param'); }
    
            // Get invoice data
            const response = await axios.get(config.backendUrl + '/order/payin-invoice-data?orderHash=' + urlParamsObj.orderHash)
            .catch(error => alert(error.response.data.message));
            // console.log(response.data); // for debugging

            const invoiceData = response.data;
            if (!invoiceData.url || !invoiceData.method) { return alert('Invalid invoiceData'); }

            // Get and submit form
            const scriptStr = getScriptString(invoiceData);
            const scriptText = document.createTextNode(scriptStr);
            const script = document.createElement('script');
            script.async = true;
            script.appendChild(scriptText);

            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
            };
        };
        main();
    }, []);

    const getScriptString = (invoiceData) => {
        let scriptStr = "const form = document.createElement('form');";
        scriptStr += "form.action = '" + invoiceData.url + "';";
        scriptStr += "form.method = '" + invoiceData.method + "';";
        // if (invoiceData.target) { scriptStr += "form.target = '" + invoiceData.target + "';"; }
        if (invoiceData['accept-charset']) { scriptStr += "form['accept-charset'] = '" + invoiceData['accept-charset'] + "';"; }
        scriptStr += "let input;";

        for (let key in invoiceData.inputs) {
            scriptStr += "input = document.createElement('input');";
            scriptStr += "input.name = '" + key + "';";
            scriptStr += "input.value = '" + invoiceData.inputs[key] + "';";
            scriptStr += "input.type = 'hidden';";
            scriptStr += "form.appendChild(input);";
        }

        scriptStr += "document.body.appendChild(form);";
        scriptStr += "form.submit();";

        return scriptStr;
    };

    return (
        <>
        </>
    );
};
